import styled from 'styled-components';

export const ToolWrapper = styled.div.attrs<{ style?: React.CSSProperties }>(({ style }) => ({
  style,
}))`
  background-color: #fff;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  .tool-header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    background-color: white;

    div {
      font-size: 18px;
      font-weight: 500;
      margin: 0 5px;
      display: flex;
      align-items: center;

      span {
        margin-left: 5px;
      }
    }
  }
  .right {
    position: absolute;
    right: 0;
    z-index: 9;
  }
`;

export const FloatToolsDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  > span {
    color: #4c4b4b;
  }
  > div {
    /* background-color: #d9d9d9; */
    border-radius: 4px;
    padding: 10px;
    display: flex;
    margin-left: 10px;
    justify-content: space-between;
  }
`;

export const OutPutWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  margin-top: 120px;
  margin-left: 50px;
  width: fit-content;
  padding: 12px 60px 12px 12px;
  max-width: 75%;
  .output-title {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    width: fit-content;
    span {
      display: inline-block;
      margin-left: 10px;
    }
  }
`;
